module.exports = __webpack_public_path__ + "img/format_list_bulleted.b60f9596.svg";